module.exports = __webpack_public_path__ + "static/media/Reload.a3bda115.svg";